import { Switch, Route, useHistory, useRouteMatch } from "react-router-dom";
import { ProgrammeProps } from "../Props";
import { useDispatch, useSelector } from "react-redux";
import { LoadingPage } from "../LoadingPage";
import { IneligibleScreen } from "../ResultScreens";
import SexChecker from "./SexChecker";
import PregnancyChecker from "../PregnancyChecker/PregnancyChecker";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { useEffect } from "react";
import { PowerOfTen, ProgressStepEnum, setStepProgress } from "../../../../redux/slices/progressBarSlice";

const LoadingScreen = () => {
  const history = useHistory();
  const pageData = useSelector((state: any) => state.signupFlowData.signupPagesData?.sex?.loadingScreen);
  return (
    <LoadingPage
      callback={() => history.replace("/physical-health")}
      heading={pageData.title ?? ""}
      text={pageData.body ?? ""}
      isLoading={false}
    />
  );
};

const PregnancyIneligibleScreen = ({ programmeTitle }: Readonly<ProgrammeProps>) => {
  const pageData = useSelector(
    (state: any) => state.signupFlowData.signupPagesData?.sex?.ineligibleScreens?.ineligiblePregnancyStatus
  );
  const pageTitle = `Ineligible pregnancy | ${programmeTitle} | ${pageTitleSuffix}`;
  return (
    <IneligibleScreen
      title={pageTitle}
      heading={pageData?.title}
      bodyText={pageData?.body}
      hasContactUs={true}
    />
  );
};

interface SexCheckerRootProps extends SexCheckerProps, PregnancyCheckerProps {
  progressPercentage?: PowerOfTen;
}
export interface SexCheckerProps extends ProgrammeProps {
  sex: string | null;
  gender: string | null;
  genderIsBirthSex: boolean | null;
}

export interface PregnancyCheckerProps extends ProgrammeProps {
  isPregnant: boolean | null;
  isBreastFeeding: boolean | null;
}

function SexCheckerRoot(props: Readonly<SexCheckerRootProps>) {
  const { programmeTitle, progressPercentage } = props;
  const { path } = useRouteMatch();

  const dispatch = useDispatch();

  useEffect(() => {
    if (progressPercentage) {
      dispatch(
        setStepProgress({
          progressStepEnum: ProgressStepEnum.CheckEligiblity,
          progressPercentage: progressPercentage,
        })
      );
    }
  }, [dispatch, progressPercentage]);

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <SexChecker {...props} />
      </Route>
      <Route exact path={`${path}/pregnancy`}>
        <PregnancyChecker {...props} />
      </Route>
      <Route path={`${path}/pregnancy/fail`}>
        <PregnancyIneligibleScreen programmeTitle={programmeTitle} />
      </Route>
      <Route path={`${path}/loading`} component={LoadingScreen} />
    </Switch>
  );
}

export default SexCheckerRoot;
